import React from "react";

export default function hairBald(_props: { color: string }): React.ReactElement | null {
  // Bald style - no hair rendered
  return null;
}
